import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Collapse,
  List,
  ListItemIcon,
  ListItemButton,
  ListItemText,
  Typography,
  Tooltip
} from '@mui/material';
import NavItem from '../NavItem';
import { MenuItemType } from '../../../../../menu-items';
import { IconChevronDown, IconChevronUp } from '@tabler/icons';
import HelpIcon from '@mui/icons-material/Help';
import { useLocation } from 'react-router-dom';

interface NavCollapseProps {
  menu: MenuItemType;
  open?: boolean;
  nestLevel?: number;
}

const NavCollapse: React.FC<NavCollapseProps> = ({ menu, open, nestLevel }: NavCollapseProps) => {
  const theme = useTheme();
  const location = useLocation();
  const pathArray = location.pathname.split('/');

  const [openCollapse, setOpenCollapse] = useState<boolean>(false);
  const [selected, setSelected] = useState<string | null>(null);

  const handleClick = () => {
    setOpenCollapse(!openCollapse);
    setSelected(!selected ? menu.id : null);
  };
  let mainpath = '';
  if (pathArray.length > 1) {
    mainpath = '/' + pathArray[1];
  }
  let selectedChildren = false;
  // menu collapse & item
  const menus = menu.children?.map((item) => {
    if (item.url == mainpath) {
      selectedChildren = true;
    }
    switch (item.type) {
      case 'collapse':
        return (
          <NavCollapse
            key={item.id}
            menu={item}
            open={open}
            nestLevel={nestLevel ? nestLevel + 1 : 1}
          />
        );
      case 'item':
        return (
          <NavItem
            key={item.id}
            item={item}
            open={open}
            nestLevel={nestLevel ? nestLevel + 1 : 1}
          />
        );
      case 'hidden':
        return null;
      default:
        return (
          <Typography key={item.id} variant="button" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <ListItemButton
        sx={{
          mb: 0,
          alignItems: 'flex-start',
          bgcolor: 'inherit',
          py: 1,
          pl: open ? 3 * (nestLevel ? nestLevel : 0) + 2.5 : null,
          borderBottom: !open && selected ? 1 : 0,
          '&:hover': {
            bgcolor: 'inherit',
            color: theme.palette.text.secondary
          },
          '&.Mui-selected': {
            bgcolor: '#21aeee1f',
            color: 'black !important'
          },
          ':hover': {
            bgcolor: '#21aeee0e'
          },
          '&.Mui-selected::after': {
            width: '5px',
            background: theme.palette.primary.main,
            height: '100%',
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 0
          }
        }}
        selected={selectedChildren && !selected}
        onClick={handleClick}
      >
        <ListItemIcon
          sx={{
            minWidth: '30px',
            mr: open ? 1 : 'auto',
            justifyContent: 'center',
            alignSelf: 'center'
          }}
        >
          <Tooltip title={!open ? (menu.title ? menu.title : '') : ''}>
            {menu.iconElement ? menu.iconElement : <HelpIcon />}
          </Tooltip>

          {/* <ArrowForwardIosIcon /> */}
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography variant="itemManu" color="black" sx={{ my: 'auto' }}>
              {menu.title}
            </Typography>
          }
          sx={{ opacity: open ? 1 : 0 }}
        />
        {openCollapse ? (
          <IconChevronUp
            stroke={1.5}
            size="1rem"
            color="black"
            style={{ marginTop: 'auto', marginBottom: 'auto' }}
          />
        ) : (
          <IconChevronDown
            stroke={1.5}
            size="1rem"
            color="black"
            style={{ marginTop: 'auto', marginBottom: 'auto' }}
          />
        )}
      </ListItemButton>
      <Collapse
        in={openCollapse}
        timeout="auto"
        unmountOnExit
        sx={{
          borderBottom: !open && selected ? 1 : 0
        }}
      >
        <List
          component="div"
          disablePadding
          sx={{
            position: 'relative'
          }}
        >
          {menus}
        </List>
      </Collapse>
    </>
  );
};

export default NavCollapse;
